module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lepus/lep_constellaton-5feae49febe0d4f3173feef7db20e01b.jpg";